<template>
  <div>
    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <article class="tile is-child box">
          <div class="child is-box box">
              <p style="font-size:1.5rem;">Create Fixture</p>
              <form>
                
              <div class="control is-horizontal">
                <div class="control-label">
                  <label class="label">Home Team</label>
                </div>
                <div class="control">
                <select class="select is-fullwidth" v-model="newFixture.home_team">
                  <option v-for="option in teamOptions" v-bind:value="option.value">
                    {{ option.text }}
                  </option>
                </select>               
                </div>
              </div>
              <div class="control is-horizontal">
                <div class="control-label">
                  <label class="label">Away Team</label>
                </div>
                <div class="control">
                <select class="select is-fullwidth" v-model="newFixture.away_team">
                  <option v-for="option in teamOptions" v-bind:value="option.value">
                    {{ option.text }}
                  </option>
                </select>               
                </div>
              </div>
              <div class="control is-horizontal">
                <div class="control-label">
                  <label class="label">Competition</label>
                </div>
                <div class="control">
                <select class="select is-fullwidth" v-model="newFixture.competition">
                  <option v-for="option in competitionOptions" v-bind:value="option.value">
                    {{ option.text }}
                  </option>
                </select>               
                </div>
              </div>
              <div class="control is-horizontal">
                <div class="control-label">
                  <label class="label">Game Date</label>
                </div>
                <div class="control is-grouped">
                    <datepicker  placeholder="--:--" :config="{  dateFormat:'Y-m-d', maxDate:'2025-06-01', minDate:'2021-09-01', enableTime: false, enableSeconds: true, noCalendar: false, time_24hr:true }" v-model="newFixture.match_date"></datepicker>
                </div>
              </div>
              <div class="control is-horizontal">
                <div class="control-label">
                  <label class="label">Season</label>
                </div>
                <div class="control is-grouped">
                     <input class="input" disabled type="text" placeholder="" value="2022 - 2023">
                </div>
              </div>
              <div class="control is-horizontal">
                <div class="control-label">
                  <label class="label">Game Venue </label>
                </div>
                <div class="control is-grouped">
                     <input class="input" type="text" placeholder="IAW Skydome...etc" v-model="newFixture.location" required>
                </div>
              </div>
              <div class="control is-horizontal">
                <div class="control-label">
                  <label class="label">EIHL ID</label>
                </div>
                <div class="control is-grouped">
                     <input class="input" type="number" placeholder="1099" v-model="newFixture.eihl_id" required>
                </div>
              </div>
              <div class="control is-horizontal">
                <div class="control-label">
                  <label class="label">Is Streamed?</label>
                </div>
                <div class="control is-grouped">
                     <input class="checkbox" type="checkbox"  v-model="newFixture.is_stream" required>
                </div>
              </div>
                <button type="submit" name="submit" @click="createFixture" class="button is-primary">Submit</button>
                <button class="button is-default">Clear</button>
              </form>
          </div>

          <div class="block-content">
            <table class="table is-child box is-responsive">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Date</th>
                  <th>Competition</th>
                  <th>Venue</th>
                  <th>Home Team</th>
                  <th></th>
                  <th></th>
                  <th>Away Team</th>
                  <th>Stream</th>
                  <th>EIHL ID</th>
                  <th>Actions</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <tr v-for="fixture in Fixtures" v-bind:key="fixture.id" v-bind:class="{'unverified': fixture.is_validated == 0,  'verified': fixture.is_validated == 1}">
                    <td>{{fixture.id}}</td>
                    <td>{{fixture.match_date}}</td>
                    <td>{{fixture.competition}}</td>
                    <td>{{fixture.location}}</td>
                    <td>{{fixture.home_team.name}} </td>
                    <td><img class="team_logo" :src="fixture.home_team.logo"></td>
                    <td><img class="team_logo" :src="fixture.away_team.logo"></td>
                    <td>{{fixture.away_team.name}}</td>
                    <td>{{fixture.is_stream}}</td>
                    <td>{{fixture.eihl_id}}</td>
                    <td>
                      <router-link class="button is-success" :to="'../../stats/match-verifier/' + fixture.id">Verifier</router-link>
                    </td>
                    <td>
                      <router-link class="button is-success" :to="'../../stats/match-verifier-official/' + fixture.id">Official Stats Verifier</router-link>
                    </td>
                    <td>
                      <button v-on:submit.prevent @click="deleteFixture(fixture.id)" class="button is-danger">Delete</button>
                    </td>
                  </tr>
              </tbody>
            </table>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from 'vue'
import Datepicker from 'vue-bulma-datepicker'
import Notification from 'vue-bulma-notification'
const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}
export default {
  name: 'f',
  components: {
    Datepicker
  },
  data () {
    return {
      Fixtures: [],
      Teams: [],
      teamOptions: [],
      competitionOptions: [
        {text: 'EIHL', value: 'EIHL'},
        {text: 'Challenge-Cup', value: 'Challenge-Cup'},
        {text: 'EIHL Conference', value: 'EIHL Conference'},
        {text: 'Playoffs', value: 'Playoffs'},
        {text: 'Pre-season', value: 'Pre-Season'}
      ],
      newFixture: {
        location: '',
        match_date: '',
        home_team: '',
        away_team: '',
        competition: '',
        eihl_id: '',
        is_stream: false
      }
    }
  },
  methods: {
    fetchTeams () {
      this.$http
        .get('https://devilsapi.roblutken.com/api/teams/get', {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
        })
        .then(
          response => {
            this.Teams = response.data
            console.log(JSON.stringify(this.Teams))
            for (var i = 0; i < this.Teams.length; i++) {
              console.log(this.Teams[i].name + this.Teams[i].id)
              this.teamOptions.push({text: this.Teams[i].name, value: this.Teams[i].id})
            }
          },
          response => {}
        )
    },
    fetchFixtures () {
      this.$http
        .get('https://devilsapi.roblutken.com/api/games/get', {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
        })
        .then(
          response => {
            this.Fixtures = response.data
            this.selectedData = response.data
            console.log(JSON.stringify(this.Fixtures))
          },
          response => {}
        )
    },
    createFixture () {
      console.log('New fixture is: ' + JSON.stringify(this.newFixture))
      /*eslint-disable */
      let stream = this.newFixture.is_stream
      if (stream)
        stream = 1
      else 
        stream = 0
      var formData = new FormData()
      formData.append('home_team', this.newFixture.home_team)
      formData.append('away_team', this.newFixture.away_team)
      formData.append('match_date', this.newFixture.match_date)
      formData.append('competition', this.newFixture.competition)
      formData.append('location', this.newFixture.location)
      formData.append('is_stream', stream)
      formData.append('eihl_id', this.newFixture.eihl_id)
      console.log('Form data is: ' + formData)
      this.$http
        .post('https://devilsapi.roblutken.com/api/games/add', formData, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
        })
        .then(
          response => {
            if (response.data.status === '202') {
              openNotification({
                title: 'Game Created Ok',
                message: response.data.message,
                type: 'success',
                duration: 3400
              })
              this.$router.go('Fixtures/Season/2019_2020')
            // this.$router.push('/editors/player-editor/' + this.$route.params.teamId)
            } else {
              openNotification({
                title: 'Failed to create game',
                message: response.data.message,
                type: 'danger',
                duration: 3400
              })
            }
          },
          response => {}
        )
    },
    editFixture (item) {
      this.newFixture.competition = item.competition
      this.newFixture.match_date = item.match_date
      this.newFixture.home_team = item.home_team
      this.newFixture.away_team = item.away_team
      this.newFixture.location = item.location
      this.newFixture.eihl_id = item.eihl_id
      console.log(JSON.stringify(item))
      window.scrollTo(0, 0)
    },
    deleteFixture (id) {
      this.$http
        .get('https://devilsapi.roblutken.com/api/games/delete/' + id, {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
        })
        .then(
          response => {
            if (response.data.status === '202') {
              openNotification({
                title: 'Delete Success',
                message: response.data.message,
                type: 'success',
                duration: 3400
              })
              this.$router.go('Fixtures/Season/2019_2020')
            // this.$router.push('/editors/player-editor/' + this.$route.params.teamId)
            } else {
              openNotification({
                title: 'Failed to delete',
                message: response.data.message,
                type: 'danger',
                duration: 3400
              })
            }
          },
          response => {}
        )
    },
    openNotificationWithType (type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      })
    }

  },
  created: function () {
    this.fetchFixtures()
    this.fetchTeams()
  },
  update: function () {

  }
}
</script>

<style lang="scss" scoped>
.table-responsive {
  display: block;
  width: 100%;
  min-height: 0.01%;
  overflow-x: auto;
}
.team_logo {
  width: 62px;
  height: 62px;
}
tr:hover td {
  background-color: rgb(254, 254, 254);
  color: #00d1b2;
  cursor: pointer;
}
.small {
  font-size: 1em;
  display: inline-block;
}
.table-responsive {
  display: block;
  width: 100%;
  min-height: 0.01%;
  overflow-x: auto;
}
.title {
  font-size: 32px;
}
.bold-el {
  font-size: 26px;
  font-style: bold;
}
.select {
  font-size: 20px;
}
.is-success {
  font-size: 1.2em;
}
.is-danger {
  font-size: 1.2em;
}
.td p {
  font-size: 1.5em;
}
.player_icon {
  width: 162px;
  height: 162px;
  border-radius: 50%;
  vertical-align: middle;
}
.team_text {
  font-size: 1.5em;
  margin-left: 20px;
}
.player_info {
  font-size: 1.4em;
}
.score {
  font-size: 34px;
}
.is-responsive {
  display: table;
}
.verified{
  background-color: rgba(1, 65, 1, 0.514);
  color:whitesmoke;
}
.unverified{
  background-color: rgba(131, 1, 1, 0.419);
  color:whitesmoke;
}

@media screen and (max-width: 600px) {
  .is-canvas-responsive {
    display: none;
  }
}
@media screen and (max-width: 800px) {
  .is-responsive {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    display: block;
    position: relative;
  }

  td:empty:before {
    content: "\00a0";
  }
  th,
  td {
    margin: 0;
    vertical-align: top;
  }
  th {
    text-align: left;
  }
  thead {
    border-right: solid 2px;
    display: block;
    float: left;
  }
  tr {
    display: block;
    padding: 0 10px 0 0;
  }
  th::before {
    content: "\00a0";
  }
  td,
  th {
    border-width: 0 0 1px;
  }
  tbody {
    display: block;
    width: auto;
    position: relative;
    overflow-x: auto;
    white-space: nowrap;
  }
  tr {
    display: inline-block;
    vertical-align: top;
  }
  th {
    display: block;
    text-align: right;
  }
  td {
    display: block;
    min-height: 1.25em;
    text-align: left;
  }
  th,
  td &:last-child {
    border-bottom-width: 0;
  }
  tr &:last-child td:not(:last-child) {
    //border: $table-cell-border;
    // border-width: $table-cell-border-width  ;
  }
  &.is-bordered td,
  th {
    border-width: 1px;
  }
  tr td,
  th &:last-child {
    border-bottom-width: 1px;
  }
  &:last-child td,
  th {
    border-width: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// 2018_2019_editor.vue?a3011980